var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoQty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#5D5FEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5859 11.5V8.12346C17.5857 7.86042 17.5162 7.60207 17.3846 7.37433C17.253 7.1466 17.0637 6.95748 16.8359 6.82596L11.5859 3.82596C11.3579 3.69431 11.0992 3.625 10.8359 3.625C10.5726 3.625 10.314 3.69431 10.0859 3.82596L4.83594 6.82596C4.60813 6.95748 4.41892 7.1466 4.28728 7.37433C4.15564 7.60207 4.08621 7.86042 4.08594 8.12346V14.1235C4.08621 14.3865 4.15564 14.6449 4.28728 14.8726C4.41892 15.1003 4.60813 15.2894 4.83594 15.421L10.0859 18.421C10.314 18.5526 10.5726 18.6219 10.8359 18.6219C11.0992 18.6219 11.3579 18.5526 11.5859 18.421L13.5359 17.275",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 7.36719L10.8375 11.1172L17.3625 7.36719",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 18.6172V11.1172",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7682 19.552C19.8967 19.552 21.6223 17.8264 21.6223 15.6979C21.6223 13.5693 19.8967 11.8438 17.7682 11.8438C15.6396 11.8438 13.9141 13.5693 13.9141 15.6979C13.9141 17.8264 15.6396 19.552 17.7682 19.552Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6172 15.6927L17.388 16.4635L18.9296 14.9219",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoQty);
export default __webpack_public_path__ + "static/media/poQty.6c8ce1b60b937ce57bad985af6237b0b.svg";
export { ForwardRef as ReactComponent };